export const portkeyInitEventV1 = 'portkeyInitEvent';
export const portkeyInitEvent = 'portkeyInitEventV2';
//# sourceMappingURL=provider.js.map